<ng-template #navigatorContent>
  <div
    class="bg-cp-primary-60 flex flex-col md:flex-row md:items-center gap-1 md:gap-4 rounded-lg px-3 md:px-6 py-2 text-white"
  >
    <span class="font-bold hidden md:inline text-nowrap">Tarifvergleich</span>
    <mat-checkbox [formControl]="showLeistungstexte" class="checkbox-on-dark">
      <span class="text-sm md:text-base text-white">Leistungstexte anzeigen</span>
    </mat-checkbox>
    @if (hasMultipleItems$ | async) {
      <mat-checkbox [formControl]="showOnlyDifferences" class="checkbox-on-dark">
        <span class="text-sm md:text-base text-white">Nur Unterschiede</span>
      </mat-checkbox>
    }
    @if (compare$ | async; as items) {
      <ui-download-pdf-button
        [kombinationen]="items"
        [leistungstexteAnzeigen]="showLeistungstexteValue()"
        [nurUnterschiede]="showOnlyDifferencesValue()"
      />
    }
  </div>
</ng-template>

@let compareList = compare$ | async;
<div class="pb-32">
  <div
    class="grid grid-cols-1 md:grid-cols-4 gap-4 bg-cp-gray-100 md:bg-cp-primary-40 md:p-4 rounded-lg sticky top-0 z-10"
  >
    <div class="text-white p-4 justify-center items-center hidden md:flex">Deine Tarifauswahl</div>

    @if (compareList) {
      <div class="col-span-3 overflow-x-auto" #scroller (scroll)="syncScroll(scroller)">
        <div class="flex gap-4 min-w-full px-2 md:px-0">
          @for (compareItem of compareList; track compareItem.kombinationId) {
            @if (compareItem | map: findTarif$ | async; as tarif) {
              <ui-compare-bar-item
                [ergebnis]="tarif"
                [isBest]="tarif.kombinationId === bestTarifKombinationId()"
                [logo]="(tarif.versichererBafinRegNr | map: findVersichererLogo$ | async) ?? null"
                (openAntrag)="openAntrag($event)"
                class="min-w-[270px] flex-1"
              />
            }
          }
        </div>
      </div>
    }
  </div>

  @let groupsState = groups$ | apiAsync;
  @if (groupsState.data; as groups) {
    @for (group of groups; track group.name) {
      @if (!showOnlyDifferencesValue() || (group | map: groupHasDifferences)) {
        <div class="py-4 bg-cp-primary-100 rounded-lg my-7 text-white text-center">
          <ui-headline>{{ group.name }}</ui-headline>
        </div>

        <div
          class="grid grid-cols-1 md:grid-cols-4 gap-y-3 md:gap-4 mb-4 items-center overflow-x-auto"
          #scroller
          (scroll)="syncScroll(scroller)"
        >
          @for (row of group.attribute; track row.name) {
            @if (!showOnlyDifferencesValue() || (row | map: attributHasDifferences)) {
              <div
                class="break-words whitespace-normal px-3 md:px-0 flex items-center justify-between gap-2 sticky left-0 z-[1]"
              >
                <span>{{ row.name }}</span>
                @if (row.tooltip) {
                  <mat-icon
                    svgIcon="cp-info"
                    class="text-cp-primary-100 !text-base !w-4 !h-4 cursor-help flex-shrink-0"
                    [matTooltip]="row.tooltip"
                  />
                }
              </div>
              <div class="px-2 col-span-3 flex gap-4 w-full">
                @for (box of row.values; track $index) {
                  <ui-vergleich-box
                    [item]="box"
                    [showBedingungstexte]="showLeistungstexteValue()"
                    class="min-w-[270px] flex-1"
                  />
                }
              </div>
            }
          }
        </div>
      }
    }

    @if (showOnlyDifferencesValue() && !(groups | map: anyGroupHasDifferences)) {
      <div class="flex flex-col items-center gap-6 py-12 text-center">
        <p class="text-3xl">Keine Unterschiede gefunden</p>
        <p>
          Die ausgewählten Tarife sind identisch. Deaktiviere 'Nur Unterschiede', um alle Werte zu
          sehen.
        </p>
      </div>
    }
  } @else if (groupsState.error) {
    <ui-api-error [message]="groupsState.error" />
  } @else {
    @for (attributePlaceholder of [1, 2, 3, 4, 5, 6, 7, 8]; track attributePlaceholder) {
      <div class="md:grid grid-cols-4 md:gap-4 my-4">
        <div class="hidden md:col-span-1 md:flex md:items-center md:gap-4 md:justify-between mb-4">
          <div class="ghost h-16 w-full min-w-[270px]"></div>
        </div>

        @if (compareList) {
          <div class="col-span-3 flex gap-4 px-2">
            @for (item of compareList; track item.kombinationId) {
              <div class="ghost h-16 w-full min-w-[270px]"></div>
            }
          </div>
        }
      </div>
    }
  }
</div>
